import styled from "@emotion/styled";
import { Box, IconButton } from "@mui/material";

export const Panel = styled(Box)<{ $width?: string }>`
  position: relative;
  display: flex;
  flex-direction: column;
  width: ${({ $width }) => $width ?? "min(760px, calc(100vw - 32px))"};
  box-sizing: border-box;
  min-height: ${({ theme }) => theme.coefficient * 240}px;
  padding: ${({ theme }) => theme.coefficient * 28}px;
  border-radius: 28px;
  background:
    radial-gradient(circle at top right, rgba(15, 195, 255, 0.16) 0%, transparent 34%),
    linear-gradient(180deg, #0d234f 0%, #0a1b40 100%);
  border: 1px solid rgba(255, 255, 255, 0.08);
  box-shadow: 0 28px 80px rgba(7, 18, 43, 0.42);
  overflow: hidden;
`;

export const CloseButton = styled(IconButton)`
  position: absolute;
  top: ${({ theme }) => theme.coefficient * 16}px;
  right: ${({ theme }) => theme.coefficient * 16}px;
  color: #ffffff;
  z-index: 2;

  &:hover {
    background-color: rgba(255, 255, 255, 0.08);
  }
`;

export const ContentContainer = styled.div`
  display: flex;
  width: 100%;
  overflow-x: hidden;
  overflow-y: auto;
`;

export const FooterContainer = styled.div`
  display: flex;
  width: 100%;
  margin-top: ${({ theme }) => theme.coefficient * 20}px;
  height: ${({ theme }) => theme.coefficient * 40}px;
  gap: ${({ theme }) => theme.coefficient * 16}px;
  padding: 0 ${({ theme }) => theme.coefficient * 20}px;
  justify-content: flex-end;
  box-sizing: border-box;
`;
